import { authDestination } from '../client/authContinuation';

export const signupAddress = () => new URLSearchParams(window.location.search).get('email') || sessionStorage.getItem('pabs-signup-email') || '';
const proofKey = email => `pabs-signup-proof:${email.toLowerCase().trim()}`;

export function signupDestination(path,email,target) {
  const destination = new URL(authDestination(path,target),window.location.origin);
  if (email) destination.searchParams.set('email',email.trim());
  return destination.pathname + destination.search;
}

// Keep email proof out of request URLs/referrers. Reloading this tab can resume
// setup; only the server decides whether the proof is still valid.
export function signupLinkProof(email) {
  const proof = new URLSearchParams(window.location.hash.slice(1)).get('verify');
  if (proof) {
    sessionStorage.setItem(proofKey(email),proof);
    window.history.replaceState(window.history.state,'',window.location.pathname + window.location.search);
  }
  return proof || sessionStorage.getItem(proofKey(email)) || '';
}

export const clearSignupProof = email => sessionStorage.removeItem(proofKey(email));
